import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import cx from 'classnames'
import type React from 'react'
import { useSelector } from 'react-redux'

import type { TreeItemVariants } from '@/types'
import { VARIANTS } from '../../constants'
import css from './Handler.module.scss'

type Props = {
  canDrag: boolean
  isSelected: boolean
  variant: TreeItemVariants
}

const Handler: React.FC<Props> = ({ canDrag, isSelected, variant }) => {
  const isProjectMobile = useSelector(
    migrationProjectSelector.getIsProjectMobile
  )

  return (
    <div
      className={cx(css.container, {
        [css.canDrag]: canDrag,
        [css.active]: isSelected,
        [css.mobile]: isProjectMobile,

        // variants
        [css.dashed]: variant === VARIANTS.FRAME,
      })}
    >
      <div />
      <div />
      <div />
    </div>
  )
}

export default Handler
